import { render, staticRenderFns } from "./problem-change.vue?vue&type=template&id=4218f9a5&"
import script from "./problem-change.vue?vue&type=script&lang=js&"
export * from "./problem-change.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports